import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-social-network-inprocess-forward.component.ajs.html';

const MODULE_NAME = 'agentBookingSocialNetworkInprocessForward';

class AgentBookingSocialNetworkInprocessForwardCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  isConference: string;

  $onInit() {}
}

export class AgentBookingSocialNetworkInprocessForward implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    isConference: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingSocialNetworkInprocessForwardCtrl];
}

export default MODULE_NAME;
